<!--
 * @Author: fengzhongmei
 * @Date: 2020-07-23 15:03:12
 * @LastEditors: fengzhongmei
 * @LastEditTime: 2020-09-14 10:21:00
 * @Description: 描述
 * @Copyright: Cloud-Star. Co. Ltd. All rights reserved.
-->
<template>
    <div class="module"
         style="position: relative;">
        <helpinfo :helpData="helpData" />
        <envSelect @envId="envClick"></envSelect>
        <div class="table-container"
             style="padding:15px; margin-top:-17px;">
            <input ref="copyrelay"
                   v-model="copyId"
                   class="copy-el" />
            <rc-table ref="tableSnapshot"
                      :tableAttr="tableAttr">
                <Button slot="tootipL"
                        @click="refresh">
                    <i class="icon-refresh-o-2"></i>
                </Button>
                <Button type="primary"
                        @click="addInstype"
                        slot="tootipL">
                    <i class="icon-plus-o-1"></i><span>{{$t('创建')}}</span>
                </Button>
            </rc-table>
        </div>
        <!-- 镜像转换 -->
        <Modal class="transfer-mirror"
               :width="500"
               :title="$t('镜像转换')"
               v-model="modal"
               @on-cancel="cancel"
               :mask-closable="false">
            <RadioGroup v-model="environmentalType"
                        @on-change="changeType">
                <Radio label="private">{{$t('私有镜像')}}</Radio>
                <Radio label="public">{{$t('公有镜像')}}</Radio>
            </RadioGroup>
            <div slot="footer">
                <Button @click="cancel"
                        class="ivu-btn-text">{{$t('取消')}}</Button>
                <Button type="primary"
                        :loading="loading"
                        @click="submit">{{loading ? $t('保存中') : $t('确认')}}</Button>
            </div>
        </Modal>

    </div>
</template>
<script>
import envSelect from '@c/basic/env'
import API from '@/service/api.js'
import helpinfo from '@c/basic/helpinfo'
import rcTable from '@c/basic/rcTable'
import merge from 'webpack-merge'
import { supportResOper } from '@/service/constant.js'
export default {
    name: 'envsnapshot',
    components: {
        helpinfo,
        rcTable,
        envSelect
    },
    data: function () {
        return {
            copyId: null,
            modal: false,
            loading: false,
            snapshotId: null,
            imageType: 'private',
            supportResOper: supportResOper,
            helpData: {
                type: '',
                modelName: this.$t('快照')
            },
            imageTypeflag: false,
            environmentalType: 'private',
            resTypeMap: { 'RES-VM': '实例快照', 'RES-VD': '云硬盘快照' },
            columns: [
                {
                    title: this.$t('名称') + '/ID',
                    key: 'id',
                    sortable: false,
                    columnShow: true,
                    columnsChoosed: true,
                    disabledSearch: true,
                    className: 'ellipsis',
                    resizable: true,
                    width: 200,
                    render: (h, params) => {
                        return h('div', {
                            class: 'ellipsis  resource',
                            style: { position: 'relative' }
                        }, [
                            params.row.name && h('div',
                                {
                                    class: 'ellipsis name',
                                    attrs: {
                                        title: params.row.name

                                    }
                                },
                                params.row.name
                            ),
                            params.row.uuid && params.row.uuid !== null && h(
                                'div',
                                {
                                    class: 'ellipsis',
                                    style: { width: '170px', color: '#666', paddingBottom: '5px' },
                                    attrs: {
                                        title: params.row.uuid
                                    }
                                },
                                params.row.uuid
                            ),
                            params.row.uuid && params.row.uuid !== null && h(
                                'Tooltip',
                                {
                                    class: 'rc-tips copyId',
                                    style: { position: 'absolute', left: '175px', top: '18px', width: '15px' },
                                    props: {
                                        transfer: true,
                                        placement: 'top',
                                        theme: 'light',
                                        content: this.$t('复制ID')
                                    }
                                },
                                [
                                    h('Icon', {
                                        class: 'copy-icon',
                                        style: { color: '#1f68b3', 'font-size': '14px' },
                                        props: {
                                            type: 'ios-browsers-outline'
                                        },
                                        on: {
                                            click: () =>
                                                this.copylink(
                                                    params.row.uuid
                                                )
                                        }
                                    })
                                ]
                            )
                        ]
                        )
                    }
                },
                {
                    title: this.$t('云环境'),
                    key: 'cloudEnvType',
                    sortable: true,
                    columnShow: true,
                    disabledSearch: true,
                    columnsChoosed: true,
                    className: 'ellipsis',
                    resizable: true,
                    width: 170,
                    render: (h, params) => {
                        return h('p', { attrs: { title: params.row.cloudEnvName }, class: { 'rc-ellipsis': true } }, [
                            h('i', { class: this.envIcon(params.row.cloudEnvType), style: 'margin-right: 0;' }),
                            h('span', { class: 'icon-text' }, !params.row.cloudEnvName ? this.$t('其他') : params.row.cloudEnvName)
                        ])
                    }
                },
                {
                    title: this.$t('可用区'),
                    key: 'zone',
                    className: 'ellipsis',
                    columnShow: true,
                    disabledSearch: true,
                    columnsChoosed: true,
                    resizable: true,
                    width: 120,
                    render: (h, params) => {
                        return h('div', {
                            attrs: {
                                title: params.row.zone
                            }
                        }, params.row.zone)
                    }
                },
                {
                    title: this.$t('类型'),
                    key: 'resType',
                    excludeEnvs: ['VMware', 'FusionCompute', 'CloudOS', 'Qcloud', 'HuaweiCloud', 'HCSO', 'Aws', 'Aliyun', 'ApsaraStack'],
                    sortable: true,
                    columnShow: true,
                    columnsChoosed: true,
                    disabledSearch: true,
                    className: 'ellipsis',
                    width: 100,
                    resizable: true,
                    render: (h, params) => {
                        return h('span', { attrs: { title: this.resTypeMap[params.row.resType] } }, this.resTypeMap[params.row.resType])
                    }
                },
                {
                    title: this.$t('大小') + '(GB)',
                    key: 'snapshotSize',
                    excludeEnvs: ['HCSO', 'Qcloud', 'Aliyun', 'VMware', 'FusionCompute', 'ApsaraStack'],
                    sortable: true,
                    columnShow: true,
                    columnsChoosed: true,
                    disabledSearch: true,
                    className: 'ellipsis',
                    width: 90,
                    resizable: true,
                    render: (h, params) => {
                        return h('span', this.stringUtil(params.row.snapshotSize))
                    }
                },
                {
                    title: this.$t('关联资源'),
                    key: 'resVdName',
                    sortable: true,
                    columnShow: true,
                    columnsChoosed: true,
                    disabledSearch: true,
                    className: 'ellipsis',
                    width: 120,
                    resizable: true,
                    render: (h, params) => {
                        if (params.row.resType === 'RES-VD') {
                            return h('span', { attrs: { title: params.row.resVdName } }, params.row.resVdName)
                        } else {
                            if (params.row.resVmName) {
                                if (['HuaweiCloud', 'HCSO', 'HCSO'].includes(params.row.envType)) {
                                    return h('a', { attrs: { title: params.row.resVmName }, on: { click: () => this.goHostDetail(params.row) } }, params.row.resVmName)
                                } else {
                                    return h('span', { attrs: { title: params.row.resVmName } }, params.row.resVmName)
                                }
                            } else {
                                return h('span', { attrs: { title: params.row.resVdName } }, params.row.resVdName)
                            }
                        }
                    }
                },
                {
                    title: this.$i18n.t('共享盘'),
                    key: 'diskType',
                    sortable: true,
                    columnShow: true,
                    columnsChoosed: true,
                    disabledSearch: true,
                    className: 'ellipsis',
                    width: 80,
                    resizable: true,
                    excludeEnvs: ['HuaweiCloud', 'OpenStack', 'OpenStack-Admin', 'Nine9Cloud', 'Nine9Cloud-Admin', 'ESCloud', 'ESCloud-Admin'],
                    render: (h, params) => {
                        const text = params.row.diskType === 'share' ? '是' : '否'
                        return h('span', this.$t(text))
                    }
                },
                {
                    title: this.$t('状态'),
                    key: 'status',
                    sortable: true,
                    columnShow: true,
                    columnsChoosed: true,
                    disabledSearch: true,
                    className: 'ellipsis',
                    width: 100,
                    resizable: true,
                    render: (h, params) => {
                        let state = ''
                        let component = 'statusview'
                        if (params.row.status === '01') {
                            state = this.$t('创建中')
                        } else if (params.row.status === '02') {
                            state = this.$t('创建成功')
                        } else if (params.row.status === '03') {
                            state = this.$t('创建失败')
                            component = 'syncpoptip'
                        } else if (params.row.status === '04') {
                            state = this.$t('删除中')
                        } else if (params.row.status === '05') {
                            state = this.$t('回滚中')
                        } else if (params.row.status === '06') {
                            state = this.$t('配置中')
                        } else {
                            state = this.$t('其它')
                        }
                        return h(component, {
                            props: component === 'syncpoptip' ? {
                                value: state,
                                params: {
                                    resType: 'snapshot',
                                    resSid: params.row.id
                                }
                            }
                                : {
                                    state: params.row.status,
                                    stateName: state
                                }
                        })
                    }
                },

                {
                    title: this.$t('描述'),
                    key: 'description',
                    sortable: true,
                    columnShow: true,
                    columnsChoosed: true,
                    disabledSearch: true,
                    className: 'ellipsis',
                    width: 120,
                    resizable: true,
                    render: (h, params) => {
                        return h('span', { attrs: { title: params.row.description } }, params.row.description)
                    }
                },
                {
                    title: this.$t('计费类型'),
                    key: 'billingType',
                    columnShow: true,
                    disabledSearch: true,
                    columnsChoosed: true,
                    className: 'ellipsis',
                    resizable: true,
                    width: 120,
                    align: 'center',
                    render: (h, params) => {
                        const txt = params.row.chargeType === 'PrePaid' ? this.$t('包年包月') : this.$t('按量计费')
                        const arr = [
                            h('p', {
                                attrs: { title: txt }
                            }, txt
                            )
                        ]
                        if (params.row.chargeType === 'PrePaid' && params.row.countdown && params.row.countdown !== null) {
                            let txtDay = ''
                            if (params.row.countdown >= 0 && this.$newTimeComparison(params.row.endTime)) {
                                txtDay = params.row.countdown + this.$t('天后到期')
                            } else {
                                txtDay = this.$t('已过期') + Math.abs(params.row.countdown) + this.$t('天')
                            }
                            arr.push(
                                h('div', { style: { display: 'inline-block' } },
                                    [
                                        h('Tooltip', {
                                            props: { transfer: true, placement: 'right', theme: 'light' }
                                        }, [
                                            h('p', { class: 'txt-border' }, txtDay),
                                            h('div', { slot: 'content' }, [
                                                h('p', this.$t('开始时间') + '：' + params.row.startTime || '--'),
                                                h('p', this.$t('结束时间') + '：' + params.row.endTime || '--')
                                            ])]
                                        )
                                    ])
                            )
                        }
                        return h('div', arr)
                    }
                },
                {
                    title: this.$t('所属项目'),
                    key: 'orgName',
                    sortable: true,
                    columnShow: true,
                    columnsChoosed: true,
                    disabledSearch: true,
                    className: 'ellipsis',
                    resizable: true,
                    minWidth: 100,
                    render: (h, params) => h('span', { attrs: { title: params.row.orgName } }, params.row.orgName)
                },
                // {
                //     title: this.$t('所属组织'),
                //     key: 'ownerOrgSid',
                //     columnShow: true,
                //     columnsChoosed: false,
                //     searchType: 'treeselect',
                //     searchData: [],
                //     render: (h, params) => {
                //         return h('span', {
                //             class: 'rc-ellipsis',
                //             attrs: {
                //                 title: params.row.ownerOrgName
                //             }
                //         }, params.row.ownerOrgName)
                //     }
                // },
                // {
                //     title: this.$t('创建时间'),
                //     key: 'createdDt',
                //     columnShow: true,
                //     columnsChoosed: true,
                //     disabledSearch: true,
                //     render: (h, params) => {
                //         return h('span', {
                //             class: 'rc-ellipsis',
                //             attrs: {
                //                 title: params.row.createdDt
                //             }
                //         }, params.row.createdDt)
                //     }
                // },
                {
                    title: this.$t('操作'),
                    // excludeEnvs: ['Azure'],
                    width: 200,
                    tooltip: false,
                    fixed: 'right',
                    render: (h, params) => {
                        const arr = []
                        const row = params.row
                        const type = row.cloudEnvType
                        if (!row.trial && (['HuaweiCloud', 'HCSO', 'HCSO', 'Aliyun', 'Qcloud', 'ApsaraStack'].includes(type)) && row.status !== 'deleted') {
                            arr.push(h('a', {
                                attr: { disabled: row.status !== '02' },
                                class: { disabled: row.status !== '02' },
                                on: { click: () => { row.status === '02' && this.rollbackFun(params.row) } }
                            }, this.$t('回滚')))
                        }
                        if (!row.trial && ['VMware', 'FusionCompute'].includes(type) && row.status !== 'deleted') {
                            arr.push(h('a', {
                                attr: { disabled: row.status !== '02' },
                                class: { disabled: row.status !== '02' },
                                on: { click: () => { row.status === '02' && this.recoveryFun(params.row) } }
                            }, this.$t('从快照恢复')))
                        }
                        if (!row.trial && this.supportResOper['快照']['创建云硬盘'].includes(type) && row.status !== 'deleted' && row.resType !== 'RES-VM') {
                            arr.push(h('a', {
                                attr: { disabled: row.status !== '02' },
                                class: { disabled: row.status !== '02' },
                                on: { click: () => { row.status === '02' && this.addHardDick(params.row) } }
                            }, this.$t('创建云硬盘')))
                        }
                        if (!row.trial && row.resType === 'RES-VM' && !this.$isOpenStackAdmins(params.row.cloudEnvType) && !['VMware', 'FusionCompute'].includes(params.row.cloudEnvType) && row.status === '02') {
                            arr.push(h('a', {
                                attr: { disabled: row.status !== '02' },
                                class: { disabled: row.status !== '02' },
                                on: { click: () => { (row.status === '02') && this.creatInstance(params.row) } }
                            }, this.$t('创建实例')))
                        }
                        if (!row.trial && !['VMware', 'FusionCompute'].includes(params.row.cloudEnvType) && row.resType === 'RES-VM' && row.status === '02') {
                            arr.push(h('a', {
                                attr: { disabled: row.status !== '02' },
                                class: { disabled: row.status !== '02' },
                                on: { click: () => { (row.status === '02') && this.mirrorChange(params.row.id) } }
                            }, this.$t('镜像转换')))
                        }
                        if (!row.trial && row.status !== 'deleted' && this.supportResOper['快照']['删除'].includes(type) && params.row.chargeType !== 'PrePaid') {
                            arr.push(h('a', {
                                attr: { disabled: row.status === '01' || row.status === '05' || row.status === '04' },
                                class: { disabled: row.status === '01' || row.status === '05' || row.status === '04' },
                                on: { click: () => { !(row.status === '01' || row.status === '05' || row.status === '04') && this.deleteFun(params.row) } }
                            }, this.$t('删除')))
                        }
                        if (!row.trial && row.status !== 'deleted' && this.supportResOper['快照']['删除'].includes(type) && params.row.chargeType === 'PrePaid') {
                            arr.push(h('a', {
                                attr: { disabled: row.status === '01' || row.status === '05' || row.status === '04' },
                                class: { disabled: row.status === '01' || row.status === '05' || row.status === '04' },
                                on: { click: () => { !(row.status === '01' || row.status === '05' || row.status === '04') && this.unsubscribeFun(params.row) } }
                            }, this.$t('退订')))
                        }
                        return h('div', { class: 'tbl-btn-div' }, arr)
                    }
                }
            ],
            tableAttr: {
                source: {
                    type: 'get',
                    url: this.urlFormat(API.SNAPSHOTS, false),
                    params: {
                        // resType: this.envType === 'CloudOS' ? 'RES-VD' : undefined,
                        // cloudEnvId: this.$route.params.id
                        projectId: this.$store.state.user.currentUser.projectId === 'all' ? '' : this.$store.state.user.currentUser.projectId,
                        cloudEnvId: sessionStorage.getItem('resourcesEnvId') || null
                    }
                },
                isWebsoct: true,
                wsKey: 'id',
                referenceVal: 1856,
                searchColumns: [
                    {
                        key: 'snapshotNameLike',
                        title: this.$t('名称'),
                        searchDefaultValue: ''
                    },
                    {
                        key: 'status',
                        title: this.$t('状态'),
                        searchDefaultValue: '',
                        searchType: 'select',
                        searchData: [
                            {
                                value: '',
                                name: this.$t('全部')
                            },
                            {
                                value: '01',
                                name: this.$t('创建中')
                            },
                            {
                                value: '02',
                                name: this.$t('创建成功')
                            },
                            {
                                value: '03',
                                name: this.$t('创建失败')
                            },
                            {
                                value: '04',
                                name: this.$t('删除中')
                            }, {
                                value: '05',
                                name: this.$t('回滚中')
                            }
                        ]
                    }
                ],
                pageData: {
                    pageWays: 'client'
                },
                searchShow: true,
                tableSearchKey: '', // 当作查询保持的key存在
                searchDefaultValueList: [], // 默认初始化搜索标签加入
                tableColKey: '',
                isMultiSelect: false,
                columnsChooseShow: true,
                columns: []
            },
            id: '',
            instanceWs: null
        }
    },
    created () {
        this.fetchDate()
    },
    beforeDestroy () {
        // 取消websocket订阅
        if (this.instanceWs) {
            this.instanceWs.unsubscribe()
            this.$store.commit('deleteWsList', '/topic/snapshot')
        }
    },
    methods: {
        // 退订
        unsubscribeFun (row) {
            this.$router.push({
                path: '/mgt/unsubscribe',
                query: { id: row.id, link: '/mgt/snapshot' }
            })
        },
        // 云环境查询
        envClick (data) {
            this.tableAttr.source.params.cloudEnvId = data
            this.$refs.tableSnapshot && this.refresh()
        },
        // 复制剪切板
        copylink (id) {
            this.copyId = id
            this.$nextTick(() => {
                const copyrelay = this.$refs.copyrelay
                copyrelay.select()
                document.execCommand('Copy')
                this.$Message.success(this.$t('ID复制成功'))
            })
        },
        stringUtil (value) {
            if (value === '' || value === undefined || value === null) {
                return '--'
            } else {
                return value
            }
        },
        fetchDate () {
            // 取消websocket订阅
            if (this.instanceWs) {
                this.instanceWs.unsubscribe()
                this.$store.commit('deleteWsList', '/topic/snapshot')
            }
            this.handleDifEnv()
            // 查询保持
            this.tableAttr.tableSearchKey = `snapshotTable${this.id}`
            this.tableAttr.tableColKey = `snapshotTable${this.id}`

            this.tableAttr.searchDefaultValueList = []
            if (sessionStorage.ts_list && JSON.parse(sessionStorage.ts_list)[this.tableAttr.tableSearchKey]) {
                this.tableAttr.searchDefaultValueList = JSON.parse(sessionStorage.ts_list)[this.tableAttr.tableSearchKey]
            }

            // 添加所属组织
            // 查询组织
            this.axios.get(this.urlFormat(API.GET_ORGS_WHOLE, true)).then(res => {
                this.initTree(res || [])
                this.columns.forEach(item => {
                    if (item.key === 'ownerOrgSid') {
                        item.searchData = res || []
                    }
                })
                this.$refs.tableSnapshot && this.$refs.tableSnapshot.initSearchColumns()
            })
            this.$nextTick(() => {
                this.$nextTick(() => {
                    this.websoctRefesh()
                })
            })
        },
        initTree (arr) {
            arr.forEach(item => {
                if (item.children && item.children.length === 0) {
                    delete item.children
                } else {
                    this.initTree(item.children)
                }
            })
        },
        // 不同云环境下显示的表格列名不同（没有prowervc）
        handleDifEnv () {
            this.tableAttr.columns = this.columns.slice(0)
            this.tableAttr.columns = this.tableAttr.columns.filter(col => {
                let res = false
                if (!col.excludeEnvs && !col.supportEnvs) {
                    res = true
                } else if (col.supportEnvs) {
                    res = true
                }
                return res
            })

            if (this.$route.query.create) {
                this.addForRouter()
            }
        },
        refresh () {
            this.$refs.tableSnapshot && this.$refs.tableSnapshot.refreshTable()
        },
        // 通过路由create创建
        addForRouter () {
            // if (!this.hasPermission('MD2202')) return
            // 创建完成后将路由的create参数改回来,使的下次在点创建的时候继续有效
            this.$router.replace({ query: merge(this.$route.query, { create: null }) })
            setTimeout(() => {
                this.$router.push({
                    path: '/mgt/snapshots/create',
                    query: {
                        resType: 'snapshot',
                        type: 'envCreate'
                    }
                })
            }, 1000)
        },
        // 创建快照
        addInstype () {
            const routeData = this.$router.resolve({
                path: '/mgt/snapshots/create',
                query: {
                    resType: 'snapshot',
                    type: 'envCreate'
                }
            })
            window.open(routeData.href, '_blank')
        },
        addHardDick (row) {
            console.log('创建硬盘')
            // const { uuid, name, cloudEnvId } = row
            // this.$router.push({
            //     path: '/mgt/disk/create',
            //     query: {
            //         envId: cloudEnvId,
            //         additional: JSON.stringify([{
            //             key: 'snapshotId',
            //             value: uuid,
            //             label: '快照',
            //             name: name
            //         }])
            //     }
            // })
        },
        // 单个删除
        deleteFun (item) {
            this.$Modal.confirm({
                title: this.$t('删除'),
                content: this.$t('您确认要删除该快照吗？'),
                onOk: () => {
                    this.axios.delete((this.urlFormat(`${API.SNAPSHOTS}`, false) + '/' + item.id)).then(res => {
                        this.refresh()
                        this.websoctRefesh()
                    })
                }
            })
        },
        // 恢复
        recoveryFun (data) {
            this.$Modal.confirm({
                title: this.$t('恢复'),
                content: `您确定要恢复到该快照吗？\n
                实例${data.resVmName ? data.resVmName + '的数据，' : ''} 将回滚到 ${data.createdDt}。 \n当前数据将被删除，请谨慎操作。`,
                onOk: () => {
                    this.axios.post(this.urlFormat(`${API.SNAPSHOTS}`, false) + '/' + data.id).then(res => {
                        this.refresh()
                        this.websoctRefesh()
                    })
                }
            })
        },
        // 回滚
        rollbackFun (data) {
            const createdDt = data.createdDt
            this.$Modal.confirm({
                title: this.$t('回滚吗？'),
                content: `${this.$t('您确定要回滚吗？')}\n
                 ${this.$t('云硬盘')}${data.resVmName ? data.resVmName + this.$t('的数据，') : ''} ${this.$t('将回滚到')} ${createdDt}。 \n${this.$t('当前数据将被删除，请谨慎操作。')}`,
                onOk: () => {
                    this.axios.post(this.urlFormat(`${API.SNAPSHOTS}`, false) + '/' + data.id).then(res => {
                        if (res) {
                            this.refresh()
                            this.websoctRefesh()
                        }
                    })
                }
            })
        },
        changeType (res) {
            this.imageType = res
        },
        // 镜像转换
        mirrorChange (val) {
            // 设置imageType的默认值，当为openstack管理系时，默认public，反之，默认值为private; 修改bug #21776
            // this.modal = true
            // this.$isOpenStackAdmins(this.$route.query.envType) && (this.environmentalType = 'public')
            // this.snapshotId = val
        },
        cancel () {
            this.environmentalType = 'private'
            this.modal = false
            this.loading = false
        },
        submit (val) {
            this.loading = true
            this.axios.post(this.urlFormat(API.SNAPSHOTS_TO_IMAGES, false), {
                imageType: this.imageType,
                snapshotId: this.snapshotId
            }).then(res => {
                if (!res || res.status) {
                    this.cancel()
                    setTimeout(() => {
                        this.$router.push({
                            path: `/mgt/mirror/${this.$route.params.id}`,
                            query: {
                                // envType: this.$route.query.envType,
                                // envName: this.$route.query.envName,
                                // region: this.$route.query.region
                            }
                        })
                        this.refresh()
                    }, 500)
                } else {
                    this.loading = false
                }
            })
        },
        // 创建实例
        creatInstance (res) {
            this.$router.push({
                path: '/mgt/host/create'
                // query: { envId, envType, envName, snapshotName, snapshotId, region, quote }
            })
        },
        interval (func, tLength = 5000, time = 1) {
            let t = 0
            const inter = setInterval(() => {
                if (t < time) {
                    if (func) {
                        func()
                    }
                } else {
                    clearInterval(inter)
                }
                t++
            }, tLength)
        },
        websoctRefesh () {
            if (!this.$refs.tableSnapshot) return // 防止控制台报错
            this.instanceWs = this.$websocket('/topic/snapshot', (result) => {
                this.$nextTick(() => {
                    this.refresh()
                })
            })
            // 存储websocket
            this.$store.commit('addWsList', {
                url: '/topic/snapshot',
                callback: (result) => {
                    this.$nextTick(() => {
                        this.refresh()
                    })
                }
            })
        },
        goHostDetail (row) {
            this.$router.push({
                name: 'hostcloudydetail',
                params: {
                    id: row.resVmId
                },
                query: {
                    envType: row.envType,
                    quote: 'env'
                }
            })
        }
    },
    watch: {
        // 如果路由有变化，会执行该方法
        $route: 'fetchDate'
    }
}
</script>
<style lang="less" scoped>
.copy-el {
    opacity: 0;
    height: 1px;
    overflow: hidden;
    margin: 0;
    padding: 0;
}
</style>
<style lang="less">
.newRcTable .rcTable-content .ellipsis > div.copyId {
    opacity: 0;
}
.newRcTable .rcTable-content .ellipsis > div {
    .copyId {
        opacity: 0;
    }
}
.newRcTable .rcTable-content .ellipsis > div:hover {
    .copyId {
        opacity: 1;
    }
}
.newRcTable .rcTable-content .ellipsis > div {
    .name {
        line-height: 22px;
    }
    .copyId {
        line-height: 22px;
    }
}
</style>
